// Mock data for JKDC Lab website

export const labInfo = {
  name: "JKDC Lab",
  fullName: "JKDC Lab – Digital X-Ray, Dental X-Ray (OPG), ECG",
  established: "15 November 2023",
  phone: "080751 66281",
  whatsapp: "918075166281", // Format for WhatsApp link
  address: {
    line1: "Opposite Police Station",
    line2: "Chengalloor, Poojapura",
    city: "Trivandrum",
    state: "Kerala",
    pincode: "695012"
  },
  workingHours: {
    weekdays: "Monday to Saturday: 6:30 AM – 6:30 PM",
    sunday: "Sunday: 7:00 AM – 1:00 PM"
  },
  googleMapsLink: "https://maps.google.com/?q=Chengalloor+Police+Station+Poojapura+Trivandrum"
};

export const services = [
  {
    id: 1,
    title: "Digital X-Ray",
    description: "Advanced digital X-ray imaging with instant results and accurate diagnosis.",
    icon: "activity",
    image: "https://images.pexels.com/photos/6501867/pexels-photo-6501867.jpeg"
  },
  {
    id: 2,
    title: "Dental X-Ray (OPG)",
    description: "Orthopantomogram (OPG) for complete dental and jaw imaging with precision.",
    icon: "scan",
    image: "https://images.pexels.com/photos/6501863/pexels-photo-6501863.jpeg"
  },
  {
    id: 3,
    title: "ECG – 12 Channel",
    description: "Comprehensive 12-channel ECG for accurate cardiac health assessment.",
    icon: "heart-pulse",
    image: "https://images.pexels.com/photos/8442027/pexels-photo-8442027.jpeg"
  }
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1768498950637-88d073faa491",
  equipment: "https://images.pexels.com/photos/12703056/pexels-photo-12703056.jpeg"
};

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted (mock):", formData);
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      submissions.push({ ...formData, timestamp: new Date().toISOString() });
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      resolve({ success: true, message: "Your inquiry has been received!" });
    }, 1000);
  });
};
